import http from '@/utils/http'

export function getProvidedOffers(params){
    return http(`/provided_offers`,{params})
}

export function getQuickLinks(params){
    return http(`/quick_links`,{params})
}
export function addQuickLinks(data){
    return http.post(`/quick_links`,data)
}
export function getQuickLinksDetail(id){
    return http(`/quick_links/${id}`)
}
export function editQuickLinks(id,data){
    return http.put(`/quick_links/${id}`,data)
}
export function deleteQuickLinks(id){
    return http.delete(`/quick_links/${id}`)
}

export function getTemplates(params){
    return http(`/templates`,{params})
}
export function addTemplates(data){
    return http.post(`/templates`,data)
}
export function getTemplatesDetail(id){
    return http(`/templates/${id}`)
}
export function editTemplates(id,data){
    return http.put(`/templates/${id}`,data)
}
export function deleteTemplates(id){
    return http.delete(`/templates/${id}`)
}